import ALERT_RATING_TYPES from '@/pages/customalerts/enums/AlertRatingType.js'
import AlertActionType from '@/pages/customalerts/enums/AlertActionType.js'
import { paramsToQuery } from '@/base/MaUtils.js'
import { makeRequest } from '@/base/MaRequestPooler.js'
import { Store } from '@/base/constants/Store.js'

export function get() {
  return makeRequest(`/custom-alerts`)
}

/**
 * Returns integrated app list of account
 */
export function getConnectedList() {
  return makeRequest(`/account/app/connected`)
}

export function getPreview({ alertType, actionType = AlertActionType.get(this.callsign)?.[0]?.callsign, ratingType = ALERT_RATING_TYPES[0].callsign, storeName = Store.Ios }) {
  return makeRequest(`/custom-alerts/preview/${alertType}?${paramsToQuery({
    actionType,
    ratingType,
    storeName,
  })}`)
}

// user custom alert limit
export function getCustomAlertCredit() {
  return makeRequest(`/custom-alerts/credit-summary`)
}

export function deleteAlerts(data) {
  return makeRequest(`/custom-alerts`, {
    method: 'DELETE',
    data: data || [],
  })
}

export function add(data) {
  return makeRequest(`/custom-alerts`, {
    method: 'POST',
    data: data || [],
  })
}

export function update(data, id) {
  return makeRequest(`/custom-alerts/${id}`, {
    method: 'PUT',
    data: data || {},
  })
}

export function addOrUpdate(alert) {
  return alert.id ? update(alert, alert.id) : add(alert)
}

export function addKeyword({ trackId, countryCode, keyword }) {
  return makeRequest(`/custom-alerts/keyword/app/${trackId}/${countryCode}`, {
    method: 'POST',
    data: { payload: keyword },
  })
}

export function deleteKeyword({ trackId, countryCode, keyword }) {
  return makeRequest(`/custom-alerts/keyword/app/${trackId}/${countryCode}`, {
    method: 'DELETE',
    data: { payload: keyword },
  })
}

export function getKeywordAlertList({ trackId, countryCode }) {
  return makeRequest(`/custom-alerts/keyword/app/${trackId}/${countryCode}`)
}

export function enableCustomerAlert({ alertId, enabled }) {
  return makeRequest(`/custom-alerts/${alertId}/enable/${enabled}`, {
    method: 'POST',
  })
}

/* ======= CUSTOM ALERTS END ========= */

/* ======= ALERT HISTORY START ========= */
export function getAlertHistory(requestDto, includeTeam) {
  return makeRequest(`/custom-alerts/alert-history/${includeTeam}`, {
    method: 'POST',
    data: requestDto,
  })
}

export function getContentOfAlertHistory(alertId) {
  return makeRequest(`/custom-alerts/alert-history/content/${alertId}`)
}

export function unTagAlertHistory(alertIds, tag) {
  return makeRequest(`/custom-alerts/alert-history/untag/${tag}`, {
    method: 'POST',
    data: alertIds,
  })
}
